// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__1XZ1D","inputWrap":"CustomTip_inputWrap__3egor"};